import moment from "moment";

/**
 * Organiza alfabéticamente los valores en String de una columna
 * @param {string} a Texto actual del recorrido
 * @param {string} b Texto siguiente del recorrido
 * @param {string} propertyNameToCompare Nombre de la columna que se va a comparar
 * @returns
 */
export const sortAlphabetically = (a, b, propertyNameToCompare) => {
  if (a[propertyNameToCompare] < b[propertyNameToCompare]) {
    return -1;
  }
  if (a[propertyNameToCompare] > b[propertyNameToCompare]) {
    return 1;
  }
  return 0;
};

/**
 * Organiza por fecha los valores de la columna especificada
 * @param {*} a Fecha actual del recorrido
 * @param {*} b Fecha siguente del recorrido
 * @param {string} propertyNameToCompare Nombre de la columna que se va a comparar
 */
export const sortByShortDate = (a, b, propertyNameToCompare) =>
  moment(b[propertyNameToCompare], "DD/MM/YYYY").toDate() -
  moment(a[propertyNameToCompare], "DD/MM/YYYY").toDate();

/**
 * Organiza por fecha y hora los valores de la columna especificada
 * @param {*} a Fecha actual del recorrido
 * @param {*} b Fecha siguiente del recorrido
 * @param {string} propertyNameToCompare Nombre de la columna que se va a comparar
 */
export const sortByDate = (a, b, propertyNameToCompare) =>
  moment(b[propertyNameToCompare], "DD/MM/YYYY hh:mm:ss").toDate() -
  moment(a[propertyNameToCompare], "DD/MM/YYYY hh:mm:ss").toDate();
